<template>
  <!-- 票數列表 -->
  <div id="RecordNameVoteList_main">
    <div class="main">
      <div class="voteWrap">
        <div
          v-for="(item, ind) in data"
          :key="ind"
          class="block"
        >
          <div class="listTitle">
            <div class="title">
              {{ item.content }}
            </div>
            <div class="subTitle">
              戶別
            </div>
          </div>
          <div class="list">
            <div
              v-for="(vote, vote_ind) in item.ballotPreviews"
              :key="vote_ind"
              class="vote"
              @click="openInfoDialog(vote.unitOwnerId)"
            >
              <div class="tabletName">
                {{ vote.tabletName }}
              </div>
              <div class="tabletArea">
                {{ vote.tabletArea }} {{ unit }}
              </div>
              <div
                v-if="item.ballotPreviews.length !== vote_ind+1"
                class="dash"
              />
              <i
                class="icon-m-next"
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <VoteInfoDialog
      ref="voteInfoDialog"
      @refresh="refresh"
    />
  </div>
</template>
<script>
import VoteInfoDialog from './VoteInfoDialog'
import tw from '../../utils'
export default {
  components: {
    VoteInfoDialog
  },
  props: {
    data: Array,
    topicStatus: String
  },
  data () {
    const { unit } = tw
    return {
      unit
    }
  },
  mounted () {
  },
  methods: {
    openInfoDialog (id) {
      this.$refs.voteInfoDialog.openDialog(id, this.topicStatus)
    },
    refresh () {
      this.$emit('refresh')
    }
  }
}
</script>
<style lang='sass' scoped>
#RecordNameVoteList_main
  +mainLayer
  padding-top: 0px
  height: 100%
  .main
    border-radius: 0
  .voteWrap
    display: flex
    max-height: 860px
    overflow: auto
    .block
      flex: 1
      margin: 0 2px
      .listTitle
        background-color: $bgDark3
        height: 32px
        line-height: 32px
        padding: 8px 16px
        color: $mainFontColor
        text-align: left
        .title
          display: inline-block
          font-size: 23px
          margin-right: 4px
          font-weight: 600
        .subTitle
          display: inline-block
          font-size: 19px
      .list
        margin-top: 7px
        background-color: #f7f7f7
        padding: 0 16px
        text-align: left
        .vote
          cursor: pointer
          padding-top: 12px
          padding-left: 8px
          font-weight: 600
          position: relative
          box-sizing: border-box
          &:last-child
            padding-bottom: 1px
          .tabletName
            font-size: 21px
            color: $mainColor
            line-height: 29px
            margin-bottom: 4px
          i
            color: $mainColor
            position: absolute
            right: 0
            top: 18px
          .tabletArea
            font-size: 19px
            line-height: 27px
            color: $mainFontColor
            margin-bottom: 12px
          .dash
            height: 1px
            background-image: linear-gradient(to right, $borderDark4 0%, $borderDark4 50%, transparent 50%)
            background-size: 15px 1px
            background-repeat: repeat-x
</style>
